import Footer from "./components/Footer";
import Nav from './components/Nav'
import Modal from "./components/ConversionModal";
import { useState } from "react";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div class="relative overflow-hidden">
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <Nav />
      <div class="max-w-7xl mx-auto pt-11">
        <div class="relative z-10 pb-8 sm:pb-8 md:pb-8 lg:pb-28 xl:pb-0 flex items-center main-container">
          <main class="mx-auto max-w-2xl w-full px-4 sm:px-6 lg:px-8">
            <div class="sm:text-center lg:text-left">
              <h1 class="text-4xl font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                <a
                  href="https://chrome.google.com/webstore/detail/notes-tab/hngoegoklccnaghmdfodhbbpkgeblfpo?hl=en&authuser=0"
                  target="_blank"
                  rel="noreferrer"
                  class="flex text-xs font-normal bg-gray-900 w-fit p-2 rounded-full items-center gap-2 mb-4"
                >
                  <div class="text-white bg-indigo-500 rounded-full px-2 py-1">
                    CHROME EXTENSION
                  </div>
                  <div class="text-white">Download Now</div>
                  <div class="text-white">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                </a>
                <span class=" xl:inline text-white">Type notes </span>
                <span class=" text-indigo-400">on every new tab.</span>
              </h1>
              <p class="mt-3 text-base text-gray-300 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                Notes Tab is a simple markdown notes editor with fast features
                and functionality.
              </p>
            </div>
          </main>
          <div>
            <img src="/og.png" alt="" />
          </div>
        </div>
      </div>
      <div class="m-auto max-w-lg text-center gap-3 sm:gap-5 flex flex-col">
        <div class="text-white text-4xl font-bold">
          Take notes faster and easier.
        </div>
        <p class="text-base text-indigo-200 sm:text-md sm:max-w-xl sm:mx-auto md:text-md lg:mx-0">
          Simple settings, quick loading, and local storage saving. The ultimate
          “literally the basics but also cool” notes tab.
        </p>
        <a
          href="https://chrome.google.com/webstore/detail/notes-tab/hngoegoklccnaghmdfodhbbpkgeblfpo?hl=en&authuser=0"
          target="_blank"
          rel="noreferrer"
          class="w-fit mx-auto  flex items-center justify-center px-8 py-3 border border-transparent text-base text-md rounded-md text-indigo-700 bg-white hover:bg-indigo-100 transition md:py-4 md:text-lg md:px-10"
        >
          * Install on the Chrome Store *
        </a>
        <button class="text-indigo-400" onClick={() => setIsModalOpen(true)}>Not using Chrome?</button>
      </div>

      <Footer />
    </div>
  );
}

export default App;
